import { declensions } from '../constants/declensions';
import { generateExpWithNum } from './generateExpWithNum';

export const getHouseAndRoomCounts = (houseCount = 0, flatCount = 0) => {
  if (houseCount === 0 && flatCount === 0) return 'Нет помещений';

  const parts = [];

  if (houseCount > 0) {
    parts.push(generateExpWithNum(houseCount, declensions.houses));
  }

  if (flatCount > 0) {
    parts.push(generateExpWithNum(flatCount, declensions.room));
  }

  return parts.join(', ');
};
